/* Energy Unleashed — bundle selector.
 *
 * Structure mirrors Kaching: flavour slots live INSIDE the selected tier card,
 * and tapping a slot opens a brand accordion rather than a flat grid — which
 * keeps the picker short on mobile where a 52-card grid is unusable.
 *
 * Adds each chosen tin as its own cart line tagged with a shared `_bundle_id`
 * so the deployed discount function can regroup them and price the group to its
 * flat tier price. Nothing here sets a price — line properties are
 * customer-editable, so the function is the only authority.
 */
(function () {
  'use strict';

  var SINGLE_TIN_CENTS = 2995;

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/, v)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    return '$' + v;
  }

  /* Business-day estimate from the shipping rate card.
   *
   * Weekends only — public holidays would need a calendar we do not have, so
   * the number is a floor, not a promise. Driven by data attributes so the
   * window widens in one place when the rate card does. */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function etaLabel(days) {
    if (!days) return '';
    var d = addBusinessDays(new Date(), days);
    return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'long' });
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'eu-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function Selector(root) {
    this.root = root;
    this.tiers = JSON.parse(root.getAttribute('data-tiers'));
    this.hideSoldOut = root.getAttribute('data-hide-soldout') === 'true';
    this.currentVariant = parseInt(root.getAttribute('data-current-variant'), 10) || null;
    this.etaStandard = parseInt(root.getAttribute('data-eta-standard'), 10) || 0;
    this.etaExpress = parseInt(root.getAttribute('data-eta-express'), 10) || 0;

    var raw = document.getElementById('eu-bundle-data');
    var data = raw ? JSON.parse(raw.textContent) : { tins: [], pouchRange: { min: 0, max: 0 } };
    this.tins = data.tins || [];
    this.pouchRange = data.pouchRange || { min: 0, max: 0 };
    this.moneyFormat = data.moneyFormat || '';

    this.anyAvailable = this.tins.some(function (t) { return t.available && t.cap > 0; });
    if (!this.anyAvailable) this.hideSoldOut = false;

    this.tier = null;
    this.slots = [];
    /* Only a deliberate action persists a draft. Merely LOADING a product page
     * fills slot 0 via prefill_current, and writing that out would make every
     * collection page announce "Bundle in progress — 1 of 5 chosen" to someone
     * who has done nothing but look at a tin. */
    this.userTouched = false;
    this.openSlot = null;
    this.openBrand = null;
    this.query = '';

    this.el = {
      modal: root.querySelector('[data-eu-modal]'),
      tiers: root.querySelector('[data-eu-tiers]'),
      summary: root.querySelector('[data-eu-summary]'),
      error: root.querySelector('[data-eu-error]'),
      notice: root.querySelector('[data-eu-notice]'),
      atc: root.querySelector('[data-eu-atc]'),
      sticky: root.querySelector('[data-eu-sticky]'),
      stickyInfo: root.querySelector('[data-eu-sticky-info]'),
      stickyAtc: root.querySelector('[data-eu-sticky-atc]')
    };

    this.init();
  }

  Selector.prototype.tin = function (id) {
    for (var i = 0; i < this.tins.length; i++) if (String(this.tins[i].id) === String(id)) return this.tins[i];
    return null;
  };

  /* How many of this tin may be chosen.
   *
   * When the whole catalogue reads as unavailable that is a store
   * configuration problem, not real stock — so the selector stays clickable for
   * evaluation and add-to-cart is what blocks. Once stock is genuinely visible
   * this returns the real per-variant cap again. */
  Selector.prototype.capOf = function (t) {
    if (!t) return 0;
    return this.anyAvailable ? t.cap : this.tier;
  };

  Selector.prototype.init = function () {
    var self = this;

    this.el.tiers.addEventListener('click', function (e) {
      var slot = e.target.closest('[data-eu-slot]');
      if (slot) { self.openPicker(parseInt(slot.getAttribute('data-eu-slot'), 10)); return; }

      var tier = e.target.closest('[data-eu-tier]');
      if (tier) { self.userTouched = true; self.selectTier(parseInt(tier.getAttribute('data-eu-tier'), 10)); }
    });

    if (this.el.modal) {
      /* Re-render on input would blur the field mid-word, so the list is
       * repainted in place and the input is left alone. */
      this.el.modal.addEventListener('input', function (e) {
        if (!e.target.matches('[data-eu-search]')) return;
        self.query = e.target.value.trim();
        self.renderResults();
      });

      this.el.modal.addEventListener('click', function (e) {
        var dec = e.target.closest('[data-eu-dec]');
        if (dec) { self.removeOne(parseInt(dec.getAttribute('data-eu-dec'), 10)); return; }
        var inc = e.target.closest('[data-eu-inc]');
        if (inc) { self.assign(parseInt(inc.getAttribute('data-eu-inc'), 10)); return; }

        if (e.target.closest('[data-eu-done]')) { self.closePicker(); self.addToCart(); return; }

        var flav = e.target.closest('[data-eu-pick]');
        if (flav && flav.getAttribute('data-disabled') !== 'true') {
          self.assign(parseInt(flav.getAttribute('data-eu-pick'), 10)); return;
        }

        var acc = e.target.closest('[data-eu-acc]');
        if (acc) { self.toggleBrand(acc.getAttribute('data-eu-acc')); return; }

        if (e.target.closest('[data-eu-search-clear]')) {
          self.query = '';
          self.render();
          var f = self.el.modal.querySelector('[data-eu-search]');
          if (f) f.focus();
          return;
        }
        if (e.target.closest('[data-eu-close]')) self.closePicker();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.openSlot != null) self.closePicker();
    });

    // The card is a div, so Enter and Space have to be wired by hand.
    if (this.el.modal) {
      this.el.modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('[data-eu-pick][role="button"]');
        if (!card) return;
        e.preventDefault();
        self.assign(parseInt(card.getAttribute('data-eu-pick'), 10));
      });
    }

    if (this.el.atc) {
      this.el.atc.addEventListener('click', function () { self.addToCart(); });
    }

    /* The sticky bar is NOT a mirror of the main button, and wiring both to
     * addToCart() was the bug.
     *
     * The main button can afford to sit disabled while the bundle is
     * incomplete: it lives inside the selector, so the slots the customer needs
     * to fill are right above it. The sticky bar appears precisely BECAUSE the
     * selector has scrolled out of view, so a disabled button there leaves
     * nothing on screen to press — and addToCart's "pick exactly N tins" error
     * renders inside the selector, off-screen, so pressing it looked like
     * nothing happened at all.
     *
     * Incomplete, it therefore opens the flavour picker on the first empty
     * slot. The picker is a fixed full-screen overlay, so this needs no
     * scrolling back up. */
    if (this.el.stickyAtc) {
      this.el.stickyAtc.addEventListener('click', function () {
        if (self.filled() === self.tier) { self.addToCart(); return; }
        var next = self.slots.indexOf(null);
        if (next !== -1) self.openPicker(next);
      });
    }

    if (!this.tins.length) {
      this.el.notice.hidden = false;
      this.el.notice.textContent = 'No bundle flavours are available right now.';
    } else if (!this.anyAvailable) {
      this.el.notice.hidden = false;
      this.el.notice.textContent =
        'Stock is showing as unavailable on the storefront, so flavours can be browsed but not added yet.';
    }

    var preset = this.tiers.filter(function (t) { return t.selected; })[0] || this.tiers[0];
    this.selectTier(preset.count);

    /* After the default tier is laid out, so adoption overwrites it cleanly. */
    var draft = window.EUBundleDraft && window.EUBundleDraft.read();
    if (draft) this.adoptDraft(draft);

    this.observeSticky();

    // The theme's own buy buttons would let a customer add a single tin with no
    // bundle properties, bypassing the selector entirely. Flag the document so
    // CSS can hide them — reversible from the theme editor, and far safer than
    // deleting blocks out of seven template files.
    if (this.root.getAttribute('data-hide-theme-atc') !== 'false') {
      document.documentElement.classList.add('eu-bundle-on');
    }

    this.reloadIfStale = this.root.getAttribute('data-reload-if-stale') === 'true';
    this.cartMode = this.root.getAttribute('data-cart-mode') || 'form';
    this.returnTo = this.root.getAttribute('data-return-to') || '/cart';

    // Re-open the drawer after a reload triggered by the staleness check, so
    // the customer lands back where they were rather than on a bare page.
    if (sessionStorage.getItem('euOpenCart')) {
      sessionStorage.removeItem('euOpenCart');
      setTimeout(function () {
        if (window.EUCart && typeof window.EUCart.refresh === 'function') {
          window.EUCart.refresh().then(function () { window.EUCart.open(); });
        }
      }, 300);
    }
  };

  /* --------------------------------------------------------- shared draft --
   * The collection-page builder and this selector are two views onto one
   * in-progress bundle (assets/eu-bundle-draft.js). Three tins picked in a
   * collection grid arrive here already chosen, and picks made here show up
   * when the customer goes back to browsing.
   *
   * Only the READ and the WRITE live here. The commit path below is untouched
   * on purpose — it is what the four cart-test suites cover.
   * -------------------------------------------------------------------------- */

  /** Persist the current picks, but only once the customer has actually acted. */
  Selector.prototype.saveDraft = function () {
    var D = window.EUBundleDraft;
    if (!D || !this.userTouched) return;

    /* One tin is a purchase, not a bundle. Persisting it would put a
     * "bundle in progress" banner on every collection page for a single tin. */
    if (!this.tier || this.tier < 3) { D.clear(); return; }

    var d = D.read() || D.start(this.tier);
    d.tier = this.tier;
    d.slots = this.slots.map(function (s) { return s == null ? null : String(s); });
    D.write(d);
  };

  /**
   * Take over an in-progress bundle. Anything the draft holds that this page
   * cannot honour — a flavour that has since sold out, or one this selector
   * does not stock — is dropped rather than rendered as an unpickable slot.
   */
  Selector.prototype.adoptDraft = function (draft) {
    var self = this;
    var offered = this.tiers.map(function (t) { return t.count; });

    var valid = draft.slots.filter(function (id) {
      if (id == null) return false;
      var t = self.tin(id);
      return !!t && self.capOf(t) > 0;
    });
    if (!valid.length) return false;

    /* Honour the draft's tier when this page offers it; otherwise take the
     * smallest offered tier that still fits what has already been picked. */
    var tier = draft.tier;
    if (offered.indexOf(tier) === -1) {
      tier = offered.filter(function (n) { return n >= valid.length; }).sort(function (a, b) { return a - b; })[0]
        || offered[offered.length - 1];
    }

    this.tier = tier;
    this.slots = [];
    for (var i = 0; i < tier; i++) this.slots.push(valid[i] != null ? valid[i] : null);

    /* No prefill here, deliberately. `valid` is compacted before it is laid
     * into slots, so slot 0 always holds a real pick by this point — and
     * pushing the product being viewed on top of a pick the customer made
     * elsewhere is exactly the bug this whole handover exists to avoid. The
     * empty-draft case never reaches here; it returned false above. */

    this.openSlot = null;
    this.openBrand = null;
    this.userTouched = true;   // already a real build; keep persisting it
    this.render();
    return true;
  };

  /* ------------------------------------------------------------- state --- */

  Selector.prototype.selectTier = function (count) {
    var keep = this.slots.slice(0, count);
    this.tier = count;
    this.slots = [];
    for (var i = 0; i < count; i++) this.slots.push(keep[i] || null);

    // Match Kaching: the product being viewed pre-fills the first slot.
    if (this.slots[0] == null && this.currentVariant) {
      var t = this.tin(this.currentVariant);
      if (t && this.capOf(t) > 0) this.slots[0] = t.id;
    }

    this.openSlot = null;
    this.openBrand = null;
    this.render();
  };

  Selector.prototype.openPicker = function (i) {
    this.openSlot = this.openSlot === i ? null : i;
    /* Tapping a slot that already holds a flavour means "change this one", not
     * "add another". Without the distinction a full bundle would let a tap
     * overwrite whatever the cursor happened to be resting on — the count for
     * the new flavour would rise while another silently vanished. */
    this.replacing = this.openSlot != null && this.slots[this.openSlot] != null;
    this.openBrand = null;
    this.render();
  };

  /* Repaints only the results, so typing never costs the input its focus. */
  Selector.prototype.renderResults = function () {
    var body = this.el.modal.querySelector('.eu-modal__body');
    if (!body) return this.render();
    var self = this;
    var clear = this.el.modal.querySelector('[data-eu-search-clear]');

    if (this.query) {
      var q = this.query.toLowerCase();
      var hits = this.tins.filter(function (t) {
        if (self.hideSoldOut && self.capOf(t) < 1) return false;
        return (t.flavour + ' ' + t.brand + ' ' + (t.notes || '')).toLowerCase().indexOf(q) !== -1;
      });
      body.innerHTML = hits.length
        ? '<div class="eu-fgrid">' + hits.map(function (t) { return self.flavourHtml(t); }).join('') + '</div>'
        : '<p class="eu-modal__none"><b>No flavours found</b>Try another flavour or brand.</p>';
      if (!clear) {
        var wrap = this.el.modal.querySelector('.eu-modal__search');
        if (wrap) wrap.insertAdjacentHTML('beforeend',
          '<button type="button" class="eu-search__clear" data-eu-search-clear aria-label="Clear search">&times;</button>');
      }
    } else {
      if (clear) clear.remove();
      this.render();
    }
  };

  Selector.prototype.pickerFootHtml = function () {
    var filled = this.filled();
    var left = this.tier - filled;
    var cfg = this.cfg();
    if (left > 0) {
      return '<div class="eu-modal__foot">' +
        '<span>' + filled + ' of ' + this.tier + ' Selected · Choose ' + left + ' More</span>' +
      '</div>';
    }
    return '<div class="eu-modal__foot" data-complete="true">' +
      '<button type="button" class="eu-modal__done" data-eu-done>' +
        'Add ' + this.tier + ' Tins to Cart · ' + money(cfg.price, this.moneyFormat) +
      '</button>' +
    '</div>';
  };

  Selector.prototype.closePicker = function () {
    this.query = '';
    this.openSlot = null;
    this.openBrand = null;
    this.render();
  };

  Selector.prototype.toggleBrand = function (brand) {
    this.openBrand = this.openBrand === brand ? null : brand;
    this.render();
  };

  Selector.prototype.assign = function (id) {
    if (this.openSlot == null) return;
    var t = this.tin(id);
    if (!t || this.usage(id) >= this.capOf(t)) return;
    // Full bundle and not explicitly changing a slot: nothing to add to.
    if (!this.canAdd() && !this.replacing) return;

    var wasReplacing = this.replacing;
    this.userTouched = true;
    this.slots[this.openSlot] = id;
    this.replacing = false;

    /* Jump to the next empty slot so a 10-pack is a run of taps, not a hunt.
     * On the last one the picker stays open rather than vanishing — a modal
     * that disappears mid-flow leaves the customer unsure whether it worked.
     * The footer turns into the add-to-cart action instead. */
    var next = this.slots.indexOf(null);
    if (next !== -1) { this.openSlot = next; this.render(); return; }

    // A replacement that leaves the bundle full has finished its job.
    if (wasReplacing) { this.closePicker(); return; }
    this.render();
  };

  /** Is there anywhere for another tin to go? */
  Selector.prototype.canAdd = function () {
    return this.filled() < this.tier;
  };

  /* Frees the last slot holding this flavour, then parks the cursor on the
   * gap it just made so the next tap refills it. */
  Selector.prototype.removeOne = function (id) {
    this.userTouched = true;
    for (var i = this.slots.length - 1; i >= 0; i--) {
      if (String(this.slots[i]) === String(id)) { this.slots[i] = null; break; }
    }
    var next = this.slots.indexOf(null);
    if (next !== -1) this.openSlot = next;
    this.replacing = false;
    this.render();
  };

  Selector.prototype.usage = function (id) {
    var n = 0;
    for (var i = 0; i < this.slots.length; i++) if (String(this.slots[i]) === String(id)) n++;
    return n;
  };

  Selector.prototype.filled = function () {
    return this.slots.filter(function (s) { return s != null; }).length;
  };

  /** Which estimate a perk bar is promising, if any. */
  Selector.prototype.perkEta = function (perk) {
    var p = String(perk || '');
    if (/express/i.test(p)) return etaLabel(this.etaExpress);
    if (/standard/i.test(p)) return etaLabel(this.etaStandard);
    return '';
  };

  Selector.prototype.cfg = function () {
    var c = this.tier;
    return this.tiers.filter(function (t) { return t.count === c; })[0];
  };

  /* Pouches and price per pouch for a tier.
   *
   * Every brand ships 20 pouches per tin, so both numbers are fixed the moment
   * a tier is chosen and there is nothing to narrow as flavours are picked.
   * This was not always true: BERSERKER was believed to hold 15, which is why
   * this used to project a live range that tightened with every selection.
   * Confirmed at 20 across every brand on 2026-08-08.
   *
   * The counts are still read from the catalogue rather than hard-coded, so a
   * brand that does ship something else degrades to an honest range instead of
   * printing a confident lie. */
  Selector.prototype.pouches = function (count) {
    return { lo: count * this.pouchRange.min, hi: count * this.pouchRange.max };
  };

  Selector.prototype.perPouch = function (price, pouches) {
    return money(Math.round(price / pouches), this.moneyFormat);
  };

  Selector.prototype.pouchLine = function (t) {
    var p = this.pouches(t.count);
    if (!p.hi) return t.count + (t.count === 1 ? ' Tin' : ' Tins');
    var per = this.perPouch(t.price, p.hi);
    return p.lo === p.hi
      ? p.hi + ' Pouches • ' + per + ' per pouch'
      : p.lo + '–' + p.hi + ' Pouches • From ' + per + ' per pouch';
  };

  /* ------------------------------------------------------------ render --- */

  Selector.prototype.render = function () {
    var self = this;

    this.saveDraft();

    this.el.tiers.innerHTML = this.tiers.map(function (t) {
      var sel = t.count === self.tier;
      var full = t.count * SINGLE_TIN_CENTS;
      var sub = self.pouchLine(t);

      return '<div class="eu-tier" role="radio" aria-checked="' + sel + '" tabindex="0" data-eu-tier="' + t.count + '">' +
        (t.badge ? '<span class="eu-tier__badge">' + esc(t.badge) + '</span>' : '') +
        '<div class="eu-tier__row">' +
          '<span class="eu-tier__radio"></span>' +
          '<span>' +
            '<span class="eu-tier__title">' + t.count + (t.count === 1 ? ' TIN' : ' TINS') +
              (t.label ? '<span class="eu-tier__label">' + esc(t.label) + '</span>' : '') +
            '</span>' +
            '<span class="eu-tier__sub">' + sub + '</span>' +
          '</span>' +
          '<span class="eu-tier__prices">' +
            '<span class="eu-tier__price">' + money(t.price, self.moneyFormat) + '</span>' +
            (full > t.price ? '<span class="eu-tier__compare">' + money(full, self.moneyFormat) + '</span>' : '') +
          '</span>' +
        '</div>' +
        (t.highlight ? '<div class="eu-tier__highlight">✓ ' + esc(t.highlight) + '</div>' : '') +
        (sel ? '<div class="eu-slots">' + self.slotsHtml() + '</div>' : '') +
        (t.perk
          ? '<div class="eu-tier__perk">' + esc(t.perk) +
              (self.perkEta(t.perk) ? '<span>Get it by ' + esc(self.perkEta(t.perk)) + '</span>' : '') +
            '</div>'
          : '') +
      '</div>';
    }).join('');

    this.renderModal();
    // Stop the page scrolling behind the modal on mobile.
    document.documentElement.style.overflow = this.openSlot == null ? '' : 'hidden';
    this.updateFooter();
  };

  /* Segmented rather than a continuous bar: the count is discrete, so one
   * segment per tin reads as "3 of 5" at a glance without needing the label. */
  Selector.prototype.progressHtml = function (compact) {
    var filled = this.filled();
    var segs = '';
    for (var i = 0; i < this.tier; i++) {
      segs += '<i class="eu-prog__seg' + (i < filled ? ' is-on' : '') + '"></i>';
    }
    var done = filled === this.tier;
    return '<div class="eu-prog' + (compact ? ' eu-prog--compact' : '') + '" data-complete="' + done + '">' +
      '<div class="eu-prog__bar">' + segs + '</div>' +
      '<span class="eu-prog__label">' +
        (done ? 'Bundle Complete' : filled + ' of ' + this.tier + ' Chosen') +
      '</span>' +
    '</div>';
  };

  Selector.prototype.slotsHtml = function () {
    var self = this;
    return this.progressHtml(false) + this.slots.map(function (id, i) {
      var t = self.tin(id);
      var open = self.openSlot === i;
      if (t) {
        return '<button type="button" class="eu-slot eu-slot--filled" data-eu-slot="' + i + '">' +
          (t.image ? '<img class="eu-slot__thumb" src="' + esc(t.image) + '" alt="" width="30" height="30">'
                   : '<span class="eu-slot__icon">•</span>') +
          '<span><span class="eu-slot__text">' + esc(t.brand) + ' – ' + esc(t.flavour) + '</span>' +
          '<span class="eu-slot__meta">' + t.pouches + ' Pouches' + (t.caffeine ? ' · ' + t.caffeine + 'mg' : '') + '</span></span>' +
          '<span class="eu-slot__change">' + (open ? 'Close' : 'Change') + '</span>' +
        '</button>';
      }
      return '<button type="button" class="eu-slot" data-eu-slot="' + i + '">' +
        '<span class="eu-slot__icon">+</span>' +
        '<span class="eu-slot__text">Choose Flavour</span>' +
        '<span class="eu-slot__change">' + (open ? 'Close' : '') + '</span>' +
      '</button>';
    }).join('');
  };

  Selector.prototype.renderModal = function () {
    var m = this.el.modal;
    if (!m) return;
    if (this.openSlot == null) { m.hidden = true; m.innerHTML = ''; return; }
    var self = this;

    /* Carry the scroll position across the repaint.
     *
     * assign() moves openSlot to the next empty one and calls render(), which
     * rebuilds this modal's innerHTML wholesale — so picking a flavour from
     * halfway down the list threw the customer back to the top, and building a
     * 5- or 10-tin bundle meant re-scrolling after every single tap.
     *
     * Captured before the rebuild; reapplied after. The cart drawer's picker
     * already did this — the selector's copy simply never got it. */
    var prevBody = m.querySelector('.eu-modal__body');
    var keepScroll = prevBody ? prevBody.scrollTop : 0;

    var pool = this.tins.filter(function (t) {
      return !(self.hideSoldOut && self.capOf(t) < 1);
    });

    var brands = [];
    pool.forEach(function (t) { if (brands.indexOf(t.brand) === -1) brands.push(t.brand); });
    brands.sort();

    /* Buyable first, sold out at the foot of each brand. With 62 flavours and
     * 21 of them out, scrolling past a wall of grey to reach something you can
     * actually pick is the wrong order — but hiding them makes people hunt for
     * a flavour they know exists, so they stay, just last. */
    var byStock = function (list) {
      return list.slice().sort(function (a, b) {
        return (self.capOf(a) > 0 ? 0 : 1) - (self.capOf(b) > 0 ? 0 : 1);
      });
    };
    var live = function (list) {
      return list.filter(function (t) { return self.capOf(t) > 0; }).length;
    };

    var sections = [{ key: 'ALL', label: 'All Brands', items: byStock(pool) }].concat(
      brands.map(function (b) {
        var items = pool.filter(function (t) { return t.brand === b; });
        return { key: b, label: b, items: byStock(items), live: live(items) };
      })
      /* A brand with nothing in stock sinks to the bottom rather than sitting
       * between two brands you can buy from. */
      .sort(function (a, b) { return (b.live > 0) - (a.live > 0); })
    );

    var rows = sections.map(function (s) {
      var open = self.openBrand === s.key;
      return '<div>' +
        '<button type="button" class="eu-acc__row" aria-expanded="' + open + '" data-eu-acc="' + esc(s.key) + '">' +
          '<span><svg class="eu-acc__chev" viewBox="0 0 24 24" width="11" height="11" aria-hidden="true">' +
            '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="3" ' +
              'stroke-linecap="round" stroke-linejoin="round"/></svg> ' + esc(s.label) + '</span>' +
          '<span class="eu-acc__count">' +
            (s.key === 'ALL' || s.live === undefined
              ? s.items.length
              : (s.live > 0 ? s.live + ' Available' : 'Sold Out')) +
          '</span>' +
        '</button>' +
        // Only the open section builds its grid. Every flavour appears twice
        // across the sections (once under All, once under its brand), so
        // rendering them all would put 100+ <img> tags in the DOM at once.
        '<div class="eu-acc__panel"' + (open ? '' : ' hidden') + '>' +
          (open ? '<div class="eu-fgrid">' + s.items.map(function (t) { return self.flavourHtml(t); }).join('') + '</div>' : '') +
        '</div>' +
      '</div>';
    }).join('');

    /* A query flattens the brand accordions: someone typing "grape" wants the
     * grape, not to be told which brand drawer to open first. Matches flavour,
     * brand and the tasting note, so "mint" finds Winterberry's cool finish
     * as well as the mints. */
    if (this.query) {
      var q = this.query.toLowerCase();
      var hits = this.tins.filter(function (t) {
        if (self.hideSoldOut && self.capOf(t) < 1) return false;
        return (t.flavour + ' ' + t.brand + ' ' + (t.notes || '')).toLowerCase().indexOf(q) !== -1;
      });
      rows = hits.length
        ? '<div class="eu-fgrid">' + hits.map(function (t) { return self.flavourHtml(t); }).join('') + '</div>'
        : '<p class="eu-modal__none"><b>No flavours found</b>Try another flavour or brand.</p>';
    } else {
      rows = '<div class="eu-acc">' + rows + '</div>';
    }

    m.innerHTML =
      '<div class="eu-modal__backdrop" data-eu-close></div>' +
      '<div class="eu-modal__panel" role="dialog" aria-modal="true" aria-label="Choose flavours">' +
        /* Sticky: 41 flavours is a long scroll, and progress plus the way out
         * must never leave the screen. "Filling Slot 2 of 5" used to sit here
         * too — three renderings of the same fact, so it is gone. */
        '<div class="eu-modal__head">' +
          '<span class="eu-modal__title">Choose Flavours' +
            this.progressHtml(false) +
          '</span>' +
          '<button type="button" class="eu-modal__close" data-eu-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="eu-modal__search">' +
          '<input type="search" class="eu-search" data-eu-search placeholder="Search flavours"' +
            ' value="' + esc(this.query) + '" autocomplete="off" autocapitalize="none"' +
            ' spellcheck="false" aria-label="Search flavours">' +
          (this.query ? '<button type="button" class="eu-search__clear" data-eu-search-clear' +
             ' aria-label="Clear search">&times;</button>' : '') +
        '</div>' +
        '<div class="eu-modal__body">' + rows + '</div>' +
        this.pickerFootHtml() +
      '</div>';
    m.hidden = false;

    /* Reapply the position captured above.
     *
     * Set twice on purpose. The first assignment lands as soon as the new
     * markup has layout, which covers the common case. But the flavour cards
     * carry <img> thumbnails, and each one that decodes afterwards grows
     * scrollHeight — if the browser clamped our scrollTop against a document
     * that was still short, the list drifts back toward the top. The rAF pass
     * re-asserts it once that settles.
     *
     * Guarded by a scroll-position check rather than applied blindly, so a
     * customer who flicks the list during that frame keeps their own scroll
     * instead of being yanked back. Same shape as the cart drawer's picker. */
    if (keepScroll > 0) {
      var nextBody = m.querySelector('.eu-modal__body');
      if (nextBody) {
        nextBody.scrollTop = keepScroll;
        var settled = nextBody.scrollTop;
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(function () {
            var el = m.querySelector('.eu-modal__body');
            if (el && el.scrollTop === settled && settled !== keepScroll) el.scrollTop = keepScroll;
          });
        }
      }
    }
  };

  /* Strength bands from the actual mg spread on this catalogue:
   * 65–75 (11 tins) · 77–80 (18) · 100 (28) · 150 (5). Objective, derived from
   * data — no invented score. */
  function strength(mg) {
    if (!mg) return null;
    if (mg < 77) return { label: 'Mild', level: 1 };
    if (mg < 100) return { label: 'Medium', level: 2 };
    if (mg < 130) return { label: 'Strong', level: 3 };
    return { label: 'Extra Strong', level: 4 };
  }

  Selector.prototype.flavourHtml = function (t) {
    var cap = this.capOf(t);
    var used = this.usage(t.id);
    var out = cap < 1;
    // Out of this flavour, at its stock cap, or the bundle simply has no room.
    var maxed = used >= cap || (!this.canAdd() && !this.replacing);
    var dis = out || maxed;
    var s = strength(t.caffeine);

    var dots = '';
    if (s) {
      for (var i = 1; i <= 4; i++) dots += '<i class="eu-dot' + (i <= s.level ? ' is-on' : '') + '"></i>';
    }

    var meta = [];
    if (s) meta.push('<span class="eu-str">' + dots + '</span>' + esc(s.label) + ' · ' + t.caffeine + 'mg caffeine');
    meta.push(t.pouches + ' Pouches');

    var badges = '';
    if (!out && cap > 0 && cap <= 5) badges += '<span class="eu-badge eu-badge--low">Only ' + cap + ' Left</span>';

    /* Compressed to "+ Nootropic Blend". Naming all three compounds on every
     * BERSERKER card cost a line each across twelve products in a 41-item list;
     * the full list is on the product page and in the title attribute. */
    var noo = t.nootropics
      ? '<span class="eu-row__noo" title="' + esc(t.actives || '') + '">+ Nootropic Blend</span>'
      : '';

    /* A div, not a button. The selected state needs a real - / + stepper
     * inside it, and nesting buttons is invalid and breaks the inner controls.
     * role + tabindex + the keydown handler keep it operable from a keyboard,
     * and the whole card stays tappable for thumbs. */
    return '<div class="eu-row" data-eu-pick="' + t.id + '"' +
      (dis ? ' data-disabled="true"' : ' role="button" tabindex="0"') +
      ' aria-label="' + esc(t.brand + ' ' + t.flavour) + (used ? ', ' + used + ' selected' : '') + '">' +
      (t.image ? '<img class="eu-row__img" src="' + esc(t.image) + '" alt="" loading="lazy" width="56" height="56">'
               : '<span class="eu-row__img"></span>') +
      '<span class="eu-row__body">' +
        '<span class="eu-row__top">' +
          '<span class="eu-row__name">' + esc(t.flavour) + '</span>' +
          (t.rating ? '<span class="eu-row__rating">★ ' + t.rating.toFixed(1) +
                      (t.reviews ? ' <i>(' + t.reviews + ')</i>' : '') + '</span>' : '') +
        '</span>' +
        (t.notes ? '<span class="eu-row__notes">' + esc(t.notes) + '</span>' : '') +
        '<span class="eu-row__meta">' + meta.map(function (m) { return '<span>' + m + '</span>'; }).join('') + badges + '</span>' +
        noo +
      '</span>' +
      '<span class="eu-row__action">' +
        (out
          ? '<span class="eu-row__state">Sold Out</span>'
          : used > 0
            /* Selected is a stepper, not a darker plus. A plus that merely
             * changes colour reads as hover, and gives no way back short of
             * hunting for the slot on the card behind. */
            ? '<span class="eu-row__qty">' +
                '<button type="button" data-eu-dec="' + t.id + '" aria-label="Remove one">&minus;</button>' +
                '<b>' + used + '</b>' +
                '<button type="button" data-eu-inc="' + t.id + '"' + (maxed ? ' disabled' : '') +
                  ' aria-label="Add another">+</button>' +
              '</span>' +
              ''
            : '<span class="eu-row__plus" aria-hidden="true">+</span>') +
      '</span>' +
    '</div>';
  };

  Selector.prototype.updateFooter = function () {
    var cfg = this.cfg();
    var filled = this.filled();
    var remaining = this.tier - filled;
    var complete = remaining === 0;

    // Fixed by the tier, so it can be stated up front rather than counted up.
    var p = this.pouches(this.tier);
    if (p.hi > 0) {
      var count = p.lo === p.hi ? p.hi : p.lo + '–' + p.hi;
      var per = this.perPouch(cfg.price, p.hi);
      /* Progress-led: the bar carries the hierarchy, the value sits beside it.
       * The flat sentence it replaced gave equal weight to three unrelated
       * facts and read as a caption. */
      var segs = '';
      for (var si = 0; si < this.tier; si++) {
        segs += '<i class="eu-sum__seg' + (si < filled ? ' is-on' : '') + '"></i>';
      }
      this.el.summary.hidden = complete;
      this.el.summary.innerHTML = complete ? '' :
        '<span class="eu-sum__bar">' + segs + '</span>' +
        '<span class="eu-sum__line">' +
          '<b>' + (complete ? 'Bundle complete' : filled + ' of ' + this.tier + ' chosen') + '</b>' +
          '<span>' + count + ' pouches · <u>' + per + '</u> per pouch</span>' +
        '</span>';
    } else {
      this.el.summary.hidden = complete;
      this.el.summary.textContent = complete ? '' : filled + ' of ' + this.tier + ' Chosen';
    }

    this.el.error.setAttribute('data-visible', 'false');

    var canAdd = complete && this.anyAvailable;
    this.el.atc.disabled = !canAdd;
    /* Split face: action on the left, state on the right, so the button keeps
     * the same shape whether it is asking or acting. */
    this.el.atc.innerHTML = complete
      ? 'Add ' + this.tier + ' Tins to Cart<span>' + money(cfg.price, this.moneyFormat) + '</span>'
      // The task is choosing flavours, not re-deciding the quantity.
      : 'Choose ' + remaining + ' More ' + (remaining === 1 ? 'Flavour' : 'Flavours') +
        '<span>' + remaining + ' Left</span>';

    if (this.el.stickyAtc) {
      /* Progress reads as a segment bar rather than a sentence — the same
       * device the summary above the main button already uses, so the sticky
       * bar looks like part of the selector instead of a separate widget.
       *
       * Segments are aria-hidden: they duplicate the count that the line below
       * states in words, and a screen reader announcing five anonymous list
       * items adds nothing.
       *
       * Two jobs, so two labels. Incomplete the button opens the picker, so it
       * reads as an action; complete it adds to cart. The count lives on the
       * info line — a button that reports state is a button not naming what
       * pressing it does. Labels stay short because the segment column takes
       * width the old text layout did not. */
      var segs = '';
      for (var qi = 0; qi < this.tier; qi++) {
        segs += '<i class="eu-sticky__seg' + (qi < filled ? ' is-on' : '') + '"></i>';
      }

      this.el.stickyAtc.disabled = complete ? !canAdd : !this.anyAvailable;
      this.el.stickyAtc.textContent = complete ? 'Add to Cart' : 'Choose';
      this.el.stickyInfo.innerHTML =
        '<span class="eu-sticky__segs" aria-hidden="true">' + segs + '</span>' +
        '<span class="eu-sticky__line"><b>' +
          this.tier + (this.tier === 1 ? ' Tin' : ' Tins') + ' · ' + money(cfg.price, this.moneyFormat) +
        '</b> · ' + (complete ? 'Complete' : remaining + ' Remaining') + '</span>';
    }
  };

  /* -------------------------------------------------------------- cart --- */

  Selector.prototype.addToCart = function () {
    var self = this;
    var cfg = this.cfg();

    if (this.filled() !== this.tier) {
      this.el.error.textContent = 'Pick exactly ' + this.tier + ' tins before adding to cart.';
      this.el.error.setAttribute('data-visible', 'true');
      return;
    }

    var bundleId = uuid();
    var label = this.tier + (this.tier === 1 ? ' Tin' : ' Tins') + (cfg.badge ? ' — ' + cfg.badge : '');

    // Merge duplicate flavours into one line with quantity — Shopify would do
    // this anyway for identical variant+properties pairs.
    var qty = {};
    this.slots.forEach(function (id) { if (id != null) qty[id] = (qty[id] || 0) + 1; });

    var items = Object.keys(qty)
      .map(function (id) {
        return {
          id: parseInt(id, 10),
          quantity: qty[id],
          properties: { _bundle_id: bundleId, _bundle_tier: String(self.tier), Bundle: label }
        };
      })
      .filter(function (it) { return it.id > 0 && it.quantity > 0; });

    var wanted = items.reduce(function (a, it) { return a + it.quantity; }, 0);
    if (wanted !== this.tier) {
      this.fail('Could not build a valid ' + this.tier + '-tin payload (got ' + wanted + '). Reload and try again.');
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root.replace(/\/?$/, '/') + 'cart/add.js';

    /* Native form POST — the route that cannot be intercepted.
     *
     * Upcart patches window.fetch and XMLHttpRequest.prototype and reconciles
     * every /cart/add.js against the cart Liquid preloaded at page render. On a
     * multi-line bundle add it pushes that stale, empty cart back to Shopify and
     * destroys the one we just built. Proven by disabling its embed: identical
     * code, perfect cart. `upcartShouldSkipAddToCartInterceptor` does not help —
     * it is only consulted by the FORM interceptor, not the XHR/fetch ones, and
     * Upcart sets it itself when ajaxRaceConditionPrevention is on.
     *
     * A real form submit is a browser navigation, so it never passes through
     * either patched function. Upcart's form handler does honour the skip flag,
     * so setting it stops that path hijacking the submit. This is what Kaching
     * effectively does, and why Kaching works on this page.
     *
     * Cost is a page load instead of a drawer sliding open. Switch the block
     * back to "ajax" once Upcart stops eating the cart. */
    if (this.cartMode === 'form') {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = root.replace(/\/?$/, '/') + 'cart/add';
      f.style.display = 'none';
      var put = function (name, value) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = name; i.value = value;
        f.appendChild(i);
      };
      items.forEach(function (it, i) {
        put('items[' + i + '][id]', it.id);
        put('items[' + i + '][quantity]', it.quantity);
        Object.keys(it.properties).forEach(function (k) {
          put('items[' + i + '][properties][' + k + ']', it.properties[k]);
        });
      });
      put('return_to', this.returnTo || '/cart');
      document.body.appendChild(f);
      window.upcartShouldSkipAddToCartInterceptor = true;
      console.log('[eu-bundle] submitting native form to', f.action, items);
      f.submit();
      return;
    }

    /* eslint-disable no-console */
    console.groupCollapsed('[eu-bundle] add to cart');
    console.log('url', url);
    console.log('payload', JSON.parse(JSON.stringify({ items: items })));
    console.groupEnd();

    this.el.atc.setAttribute('aria-busy', 'true');

    /* Tell Upcart to keep its hands off this add.
     *
     * Upcart intercepts /cart/add.js and reconciles the result against the
     * cart Liquid preloaded at page render. For a multi-line bundle add it
     * loses, and pushes that stale (empty) cart back to Shopify — wiping a
     * cart that had just been correctly populated. Proven by disabling its app
     * embed: identical code, cart came back perfect.
     *
     * `upcartShouldSkipAddToCartInterceptor` is checked in both of Upcart's
     * interceptor paths and is the documented way out. Scoped to this request
     * and restored after, so Upcart still handles every other add on the site
     * normally rather than being globally lobotomised. */
    var hadSkip = window.upcartShouldSkipAddToCartInterceptor;
    window.upcartShouldSkipAddToCartInterceptor = true;
    var restoreSkip = function () {
      setTimeout(function () { window.upcartShouldSkipAddToCartInterceptor = hadSkip; }, 2000);
    };

    // Two encodings. Some themes and cart apps wrap /cart/add.js and only
    // handle the form-encoded shape a normal product form submits — Kaching
    // works on this page, so something here is treating our JSON differently.
    // Whichever succeeds also tells us which one that is.
    function asForm(list) {
      var fd = new FormData();
      list.forEach(function (it, i) {
        fd.append('items[' + i + '][id]', it.id);
        fd.append('items[' + i + '][quantity]', it.quantity);
        Object.keys(it.properties).forEach(function (k) {
          fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]);
        });
      });
      return fd;
    }

    /* Sent over XMLHttpRequest, deliberately, NOT fetch.
     *
     * The add itself always worked — the cart read-back confirmed the lines
     * were there. What failed was Upcart noticing. Cart drawer apps detect
     * adds by monkey-patching XMLHttpRequest.prototype.open/send; a good many
     * never patched window.fetch. A fetch-based add is therefore invisible to
     * them: the cart updates server-side and the drawer keeps rendering the
     * stale, empty state it cached at page load.
     *
     * Kaching submits through the theme's product form, which goes out over
     * XHR — which is exactly why it works on this page and we didn't. */
    function attempt(mode) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.withCredentials = true;
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        if (mode === 'json') xhr.setRequestHeader('Content-Type', 'application/json');

        xhr.onload = function () {
          var body = null;
          try { body = JSON.parse(xhr.responseText); } catch (e) { /* HTML, not JSON */ }
          console.log('[eu-bundle] ' + mode + ' response', xhr.status, body || xhr.responseText.slice(0, 300));
          if (xhr.status < 200 || xhr.status >= 300) {
            var msg = (body && (body.description || body.message)) || ('HTTP ' + xhr.status);
            var err = new Error(msg); err.mode = mode; err.status = xhr.status;
            return reject(err);
          }
          self.addMode = mode;
          resolve(body);
        };
        xhr.onerror = function () { reject(new Error('Network error on ' + mode + ' add.')); };

        xhr.send(mode === 'json' ? JSON.stringify({ items: items }) : asForm(items));
      });
    }

    attempt('json')
      .catch(function (e) {
        console.warn('[eu-bundle] json add failed (' + e.message + ') — retrying form-encoded');
        self.jsonError = e.message;
        return attempt('form');
      })
      // Read the cart back. Upcart hooks /cart/add.js, so a drawer opening is
      // NOT proof anything was added — only the cart itself is.
      .then(function () {
        return fetch(root.replace(/\/?$/, '/') + 'cart.js', {
          credentials: 'same-origin', headers: { Accept: 'application/json' }
        }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var mine = (cart.items || []).filter(function (l) {
          return l.properties && l.properties._bundle_id === bundleId;
        });
        var got = mine.reduce(function (a, l) { return a + l.quantity; }, 0);
        console.log('[eu-bundle] cart now holds', got, 'of', wanted, 'for bundle', bundleId, cart);

        if (got !== wanted) {
          throw new Error('Sent ' + wanted + ' tins via ' + (self.addMode || '?') +
            ', cart came back with ' + got + '. Cart total lines: ' + (cart.item_count || 0) + '.');
        }

        // Only once the cart has confirmed the lines are actually there —
        // reporting an add that didn't land is worse than not reporting it.
        self.trackAdd(cfg);

        self.refreshDrawers(cart);

        /* The build is now a cart line. Leaving the draft behind would let the
         * same bundle be committed twice from two surfaces. */
        self.userTouched = false;
        if (window.EUBundleDraft) window.EUBundleDraft.clear();

        self.selectTier(self.tier);

        /* Self-healing fallback.
         *
         * Upcart renders from `upcartPreloadedCart`, which Liquid writes at
         * page render, and its live refresh is not picking up our add. Rather
         * than reload unconditionally — which would be a poor product-page
         * experience and unnecessary if the drawer is fine — give the drawer a
         * moment, then check what it is actually showing. Only if it still
         * disagrees with the real cart do we reload, which forces Liquid to
         * re-emit the preloaded cart and guarantees a correct drawer.
         *
         * Remove this once the interceptor question is settled. */
        if (self.reloadIfStale) {
          setTimeout(function () {
            var badge = document.querySelector('[class*="upcart"] [class*="item-count"], .upcart-header-title');
            var shown = badge ? (badge.textContent.match(/\d+/) || [null])[0] : null;
            if (shown !== null && Number(shown) !== cart.item_count) {
              console.warn('[eu-bundle] drawer shows', shown, 'but cart has', cart.item_count, '— reloading');
              sessionStorage.setItem('euOpenCart', '1');
              location.reload();
            }
          }, 900);
        }
      })
      .catch(function (err) {
        console.error('[eu-bundle] add failed', err);
        self.fail(err.message || 'Could not add to cart.');
      })
      .finally(function () {
        self.el.atc.removeAttribute('aria-busy');
        restoreSkip();
      });
  };

  /* Diagnostic toast.
   *
   * Appended to <body> at the top of the stacking order, because the Upcart
   * drawer opens over the product page and buries anything rendered inside the
   * selector — which is why the earlier in-block messages were never seen.
   * Temporary, while we chase the add-to-cart failure. */

  /* Tell whatever cart drawer is on the page to re-read.
   *
   * Upcart is the one that matters here; its functions are global and
   * individually optional, so each is probed rather than assumed. The theme's
   * own Horizon drawer is also present on this page, so its events are fired
   * too — harmless when Upcart is the visible one. Returns what it called, so
   * the diagnostic toast can report it. */
  /* The bundle add is the single most important conversion event on the site and

   * Shopify's own pixel cannot describe it — it sees N separate line items, not

   * one 5-tin bundle at a tier price. Custom, so it never collides with the

   * standard AddToCart the Meta channel already fires. */

  Selector.prototype.trackAdd = function (cfg) {

    if (!(window.EUCart && window.EUCart.track)) return;

    var self = this;

    var flavours = this.slots.map(function (id) {

      var t = self.tin(id);

      return t ? t.brand + ' ' + t.flavour : '';

    }).filter(Boolean);

    window.EUCart.track('EUBundleAdded', {

      tier: this.tier,

      value: cfg.price / 100,

      currency: 'AUD',

      num_items: this.tier,

      contents: flavours,

      content_ids: this.slots.map(String)

    });

  };

  

  Selector.prototype.refreshDrawers = function (cart) {
    var called = [];

    /* Our own drawer first. It exposes a real API (window.EUCart) precisely
     * because Upcart did not — upcartRefreshCart and upcartRegisterAddToCart
     * are no-op stubs in their bundle, which is why the drawer sat on a stale
     * empty cart no matter what we called. */
    if (window.EUCart && typeof window.EUCart.openWith === 'function') {
      try { window.EUCart.openWith(cart); called.push('EUCart'); } catch (e) { called.push('EUCart!err'); }
    } else if (typeof window.upcartOpenCart === 'function') {
      // Fallback while both are installed.
      try { window.upcartOpenCart(); called.push('upcartOpenCart'); } catch (e) {}
    }

    ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });

    return called;
  };

  Selector.prototype.fail = function (msg) {
    this.el.error.textContent = msg;
    this.el.error.removeAttribute('data-ok');
    this.el.error.setAttribute('data-visible', 'true');
  };


  /* The bar is shown while the real add-to-cart button is off-screen AND the
   * footer is not yet in view.
   *
   * The footer condition matters most on desktop, where the footer IS the
   * site navigation: a bar pinned to the bottom of the window would sit on
   * top of the payment icons and the copyright/policy row, and the customer
   * has no way to push it out of the way. By the time the footer is on screen
   * the customer has scrolled past the guarantee, the FAQ and the reviews —
   * they have had the offer four times and are now looking for something
   * else. Standing in front of it buys nothing.
   *
   * Both observers write into the same two flags rather than fighting over
   * the attribute, so whichever fires last still computes the correct state. */
  Selector.prototype.observeSticky = function () {
    var self = this;
    if (!this.el.sticky || !('IntersectionObserver' in window)) return;

    var atcOut = false;
    var footerIn = false;
    var apply = function () {
      self.el.sticky.setAttribute('data-visible', String(atcOut && !footerIn));
    };

    new IntersectionObserver(function (e) {
      atcOut = !e[0].isIntersecting;
      apply();
    }, { rootMargin: '0px 0px -120px 0px' }).observe(this.el.atc);

    /* No footer on the page is not an error — leave footerIn false and the bar
     * behaves exactly as it did before. */
    var footer = document.querySelector('footer, .footer, [class*="footer-group"]');
    if (footer) {
      new IntersectionObserver(function (e) {
        footerIn = e[0].isIntersecting;
        apply();
      }, { rootMargin: '0px 0px 0px 0px' }).observe(footer);
    }
  };

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eu-bundle]'), function (el) {
      if (!el.__euBooted) { el.__euBooted = true; new Selector(el); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
